// src/components/languageMap.js

const languageMap = {

    // ===========================================================================
    // google (LanguageList YAML)
    // ===========================================================================

    "af": "Afrikaans",
    "sq": "Shqip",
    "am": "አማርኛ",
    "ar": "العربية",
    "ar-SA": "العربية",
    "az": "Azərbaycan",
    "be": "Беларуская",
    "bn": "বাংলা",
    "bn-IN": "বাংলা",
    "bs": "Bosanski",
    "bs-Cyrl": "Босански",
    "bg": "Български",
    "my": "မြန်မာစာ",
    "ca": "Català",
    "zh": "中文 (简体)",
    "zh-CN": "中文 (简体)",
    "zh-Hans": "中文 (简体)",
    "zh-Hant": "中文 (繁體)",
    "zh-TW": "中文 (繁體)",
    "zh-HK": "中文 (繁體)",
    "hr": "Hrvatski",
    "cs": "Čeština",
    "da": "Dansk",
    "nl": "Nederlands",
    "nl-BE": "Nederlands",
    "en": "English",
    "en-US": "English",
    "en-GB": "English",
    "en-AU": "English",
    "en-CA": "English",
    "en-NZ": "English",
    "en-ZA": "English",
    "en-PH": "English",
    "et": "Eesti",
    "fil": "Filipino",
    "fi": "Suomi",
    "fr": "Français",
    "fr-CA": "Français",
    "fr-CH": "Français",
    "fy": "Frysk",
    "gl": "Galego",
    "ka": "ქართული",
    "de": "Deutsch",
    "el": "Ελληνικά",
    "gn": "Avañe'ẽ",
    "gu": "ગુજરાતી",
    "he": "עברית",
    "iw": "עברית",
    "hi": "हिन्दी",
    "hu": "Magyar",
    "is": "Íslenska",
    "id": "Indonesia",
    "it": "Italiano",
    "ja": "日本語",
    "kn": "ಕನ್ನಡ",
    "km": "ខ្មែរ",
    "ko": "한국어",
    "ky": "Кыргызча",
    "lo": "ລາວ",
    "lv": "Latviešu",
    "ln": "Lingála",
    "lt": "Lietuvių",
    "mk": "Македонски",
    "ms": "Melayu",
    "ml": "മലയാളം",
    "mr": "मराठी",
    "ne": "नेपाली",
    "nb": "Norsk",
    "no": "Norsk",
    "fa": "فارسی",
    "pl": "Polski",
    "pt": "Português",
    "pt-BR": "Português",
    "pt-PT": "Português",
    "pa": "ਪੰਜਾਬੀ",
    "pa-PK": "پنجابی",
    "ro": "Română",
    "ru": "Русский",
    "sk": "Slovenčina",
    "sl": "Slovenščina",
    "es": "Español",
    "es-419": "Español",
    "es-ES": "Español",
    "es-MX": "Español",
    "es-US": "Español",
    "sv": "Svenska",
    "sw": "Kiswahili",
    "ta": "தமிழ்",
    "te": "తెలుగు",
    "th": "ไทย",
    "tr": "Türkçe",
    "uk": "Українська",
    "ur": "اردو",
    "uz": "Oʻzbek",
    "vi": "Tiếng Việt",
    "cy": "Cymraeg",
    "zu": "isiZulu",

    // ===========================================================================
    // deepl (DeepLLanguageList YAML)
    // ===========================================================================

    "AR": "العربية",
    "BG": "Български",
    "CS": "Čeština",
    "DA": "Dansk",
    "DE": "Deutsch",
    "EL": "Ελληνικά",
    "EN": "English",
    "EN-GB": "English",
    "EN-US": "English",
    "ES": "Español",
    "ES-419": "Español",
    "ET": "Eesti",
    "FI": "Suomi",
    "FR": "Français",
    "HE": "עברית",
    "HU": "Magyar",
    "ID": "Indonesia",
    "IT": "Italiano",
    "JA": "日本語",
    "KO": "한국어",
    "LT": "Lietuvių",
    "LV": "Latviešu",
    "NB": "Norsk",
    "NL": "Nederlands",
    "PL": "Polski",
    "PT": "Português",
    "PT-BR": "Português",
    "PT-PT": "Português",
    "RO": "Română",
    "RU": "Русский",
    "SK": "Slovenčina",
    "SL": "Slovenščina",
    "SV": "Svenska",
    "TH": "ไทย",
    "TR": "Türkçe",
    "UK": "Українська",
    "VI": "Tiếng Việt",
    "ZH": "中文 (简体)",
    "ZH-HANS": "中文 (简体)",
    "ZH-HANT": "中文 (繁體)",

    // ===========================================================================
    // openai (openAILanguageList YAML)
    // ===========================================================================

    "yue": "廣東話",
    "si": "සිංහල",
    "kk": "Қазақ тілі",
    "tg": "Тоҷикӣ",
    "mn": "Монгол",
    "eu": "Euskara",

    // ===========================================================================
    // azure (Azure Speech STT Locales)
    // ===========================================================================

    "af-ZA": "Afrikaans",
    "am-ET": "Amharic",

    // Arabic
    "ar-AE": "Arabic",
    "ar-BH": "Arabic",
    "ar-DZ": "Arabic",
    "ar-EG": "Arabic",
    "ar-IL": "Arabic",
    "ar-IQ": "Arabic",
    "ar-JO": "Arabic",
    "ar-KW": "Arabic",
    "ar-LB": "Arabic",
    "ar-LY": "Arabic",
    "ar-MA": "Arabic",
    "ar-OM": "Arabic",
    "ar-PS": "Arabic",
    "ar-QA": "Arabic",
    "ar-SY": "Arabic",
    "ar-TN": "Arabic",
    "ar-YE": "Arabic",

    // A–C
    "as-IN": "Assamese",
    "az-AZ": "Azerbaijani",
    "bg-BG": "Bulgarian",
    "bs-BA": "Bosnian",
    "ca-ES": "Catalan",
    "cs-CZ": "Czech",
    "cy-GB": "Welsh",
    "da-DK": "Danish",

    // German
    "de-AT": "German",
    "de-CH": "German",
    "de-DE": "German",

    // Greek
    "el-GR": "Greek",

    // English
    "en-GH": "English",
    "en-HK": "English",
    "en-IE": "English",
    "en-IN": "English",
    "en-KE": "English",
    "en-NG": "English",
    "en-SG": "English",
    "en-TZ": "English",


    // Spanish
    "es-AR": "Spanish",
    "es-BO": "Spanish",
    "es-CL": "Spanish",
    "es-CO": "Spanish",
    "es-CR": "Spanish",
    "es-CU": "Spanish",
    "es-DO": "Spanish",
    "es-EC": "Spanish",
    "es-GQ": "Spanish",
    "es-GT": "Spanish",
    "es-HN": "Spanish",
    "es-NI": "Spanish",
    "es-PA": "Spanish",
    "es-PE": "Spanish",
    "es-PR": "Spanish",
    "es-PY": "Spanish",
    "es-SV": "Spanish",
    "es-UY": "Spanish",
    "es-VE": "Spanish",

    // E–F
    "et-EE": "Estonian",
    "eu-ES": "Basque",
    "fa-IR": "Persian",
    "fi-FI": "Finnish",
    "fil-PH": "Filipino",

    // French
    "fr-BE": "French",
    "fr-FR": "French",

    // G–H
    "ga-IE": "Irish",
    "gl-ES": "Galician",
    "gu-IN": "Gujarati",
    "he-IL": "Hebrew",
    "hi-IN": "Hindi",
    "hr-HR": "Croatian",
    "hu-HU": "Hungarian",
    "hy-AM": "Armenian",

    // I–J
    "id-ID": "Indonesian",
    "is-IS": "Icelandic",
    "it-CH": "Italian",
    "it-IT": "Italian",
    "ja-JP": "日本語",
    "jv-ID": "Javanese",
    "ka-GE": "Georgian",

    // K–L
    "kk-KZ": "Kazakh",
    "km-KH": "Khmer",
    "kn-IN": "Kannada",
    "ko-KR": "한국어",
    "lo-LA": "Lao",
    "lt-LT": "Lithuanian",
    "lv-LV": "Latvian",

    // M
    "mk-MK": "Macedonian",
    "ml-IN": "Malayalam",
    "mn-MN": "Mongolian",
    "mr-IN": "Marathi",
    "ms-MY": "Malay",
    "mt-MT": "Maltese",
    "my-MM": "Myanmar",

    // N–P
    "nb-NO": "Norwegian",
    "ne-NP": "Nepali",
    "nl-NL": "Dutch",
    "or-IN": "Odia",
    "pa-IN": "Punjabi",
    "pl-PL": "Polish",
    "ps-AF": "Pashto",

    // R–S
    "ro-RO": "Romanian",
    "ru-RU": "Russian",
    "si-LK": "Sinhala",
    "sk-SK": "Slovak",
    "sl-SI": "Slovenian",
    "so-SO": "Somali",
    "sq-AL": "Albanian",
    "sr-RS": "Serbian",
    "sv-SE": "Swedish",

    // T–V
    "sw-KE": "Swahili",
    "sw-TZ": "Swahili",
    "ta-IN": "Tamil",
    "te-IN": "Telugu",
    "th-TH": "Thai",
    "tr-TR": "Turkish",
    "uk-UA": "Ukrainian",
    "ur-IN": "Urdu",
    "uz-UZ": "Uzbek",
    "vi-VN": "Vietnamese",

    // Chinese & variants
    "wuu-CN": "Chinese",
    "yue-CN": "Cantonese",
    "zh-CN-shandong": "中文",
    "zh-CN-sichuan": "中文",

    // Z
    "zu-ZA": "isiZulu",

};

// normalizeLangCode 정규화 후 남는 소문자 canonical 코드 → 표시명
// (languageMap 원본 키는 대소문자 혼용이라 별도 정의)
const CANONICAL_NAMES = {
    'zh-cn':  '中文 (简体)',
    'zh-tw':  '中文 (繁體)',
    'pt-br':  'Português (Brasil)',
    'pt-pt':  'Português (Europa)',
    'es-419': 'Español (Latinoamérica)',
};

// 엔진별 언어코드 → 통일 코드 매핑 (소문자 변환 후 적용)
const LANG_ALIASES = {
    // 중국어 간체: DeepL=ZH, OpenAI=zh, Google=zh-CN → zh-cn으로 통일
    'zh':      'zh-cn',
    'zh-hans': 'zh-cn', // 일부 API fallback
    // 중국어 번체: DeepL=ZH-HANT, Google=zh-TW → zh-tw로 통일
    'zh-hant': 'zh-tw',
    'zh-hk':   'zh-tw',
    // Azure yue
    'yue-cn':  'yue',
};

// 지역코드가 의미 있는 언어 (구분 유지)
const REGION_SIGNIFICANT = new Set(['zh-cn', 'zh-tw', 'pt-br', 'pt-pt', 'es-419']);

export { CANONICAL_NAMES };

export function normalizeLangCode(code) {
    if (!code) return code;
    const lower = code.toLowerCase();
    if (LANG_ALIASES[lower]) return LANG_ALIASES[lower];
    // 지역코드 포함이지만 구분 불필요한 경우 base만 사용
    // ex) ja-JP → ja, ko-KR → ko, en-US → en, de-DE → de
    if (lower.includes('-') && !REGION_SIGNIFICANT.has(lower)) {
        return lower.split('-')[0];
    }
    return lower;
}

export default languageMap;
